import type { ReferentialityPluginOptions } from '@atlassian/editor-referentiality';

interface Props {
	options: ReferentialityPluginOptions;
}

export function referentialityPluginOptions({ options }: Props): ReferentialityPluginOptions {
	return {
		...options,
		api: options.api,
	};
}
